import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, TemplateRef, inject, signal } from '@angular/core';
import { FormControl, UntypedFormControl, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgbModal, NgbModalRef, NgbDropdownModule, NgbTooltipModule, NgbAccordionModule, NgbModalModule, NgbModalConfig, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Backend } from 'src/app/backend-interface/backend';
import { Detectors, Policy, RequestPolicy } from 'src/app/service/global.service';
import { ToastService } from 'src/app/service/toast.service';
import { TranslationService } from 'src/app/service/translation.service';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { HasRolesDirective } from 'keycloak-angular';
import { forkJoin } from 'rxjs';
import { ConfirmationFormComponent } from './confirmation-form/confirmation-form.component';
import { FormAddPolicyAndSimulationComponent } from '../form-add-policy-and-simulation/form-add-policy-and-simulation.component';
import { FormPolicyComponent } from '../form-policy/form-policy.component';
import Keycloak from 'keycloak-js';
import { ToastComponent } from 'src/app/components/toast/toast.component';

@Component({
  selector: 'app-details-policy',
  templateUrl: './details-policy.component.html',
  styleUrls: ['./details-policy.component.scss'],
  standalone: true,
  imports: [
    TranslateModule,
    NgbModalModule,
    HasRolesDirective,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    NgbDropdownModule,
    NgbTooltipModule,
    NgbAccordionModule,
    ConfirmationFormComponent,
    FormAddPolicyAndSimulationComponent,
    FormPolicyComponent,
    ToastComponent
  ],
  providers: [TranslationService, ToastService, NgbModal, NgbModalConfig, NgbActiveModal]
})
export class DetailsPolicyComponent implements OnInit, OnChanges {

  /**Type define from what parent component he's called*/
  @Input() type!: string

  /** policy transfer by parent composant */
  @Input() policy?: Policy

  /** Event for Simulation component */
  @Output() editPtoMain: EventEmitter<{ policy: Policy, toast: string }> = new EventEmitter<{ policy: Policy, toast: string }>()

  /** Event for ActivePolicies component */
  @Output() duplicateEvent: EventEmitter<string> = new EventEmitter<string>()

  /** Event for Simulation component */
  @Output() deletePtoMain: EventEmitter<Policy> = new EventEmitter<Policy>()

  /** Event for ActivePolicies component */
  @Output() status = new EventEmitter<{ action: string, policy: Policy }>()

  /** Event for Simulation component */
  @Output() submitPolicy = new EventEmitter<{ policy: Policy, applicationId: number }>()

  private modalref?: NgbModalRef

  private allPolicies: Policy[] | undefined
  public editform: UntypedFormControl = new FormControl()

  readonly toastService = inject(ToastService);
  readonly translationService = inject(TranslationService);
  readonly modalService = inject(NgbModal);

  readonly isAdmin = signal<boolean>(false);

  readonly keycloak = inject(Keycloak);

  familyDetectors = signal<string[]>([]);

  constructor() { }

  ngOnInit(): void {
    this.isAdmin.set(this.keycloak.hasRealmRole('bo-dip-wl-admin'));
    if (this.isAdmin() && this.policy) {
      Backend.POLICIES.getPolicies().then(policies => {
        this.allPolicies = policies;
        const itemP = this.allPolicies.find(elem => elem.name === this.policy!.name);
        if (itemP) {
          this.allPolicies.splice(this.allPolicies.indexOf(itemP), 1);
        }
        this.editform = new UntypedFormControl(this.policy!.name, [
          Validators.required,
          Backend.SETTINGS.noWhitespaceValidator(),
          Backend.POLICIES.notExistValidator(this.allPolicies)
        ]);
      });
    }
    this.familyDetectors.set(this.getAllFamilyofDetectors());
  }

  ngOnChanges() {
    this.ngOnInit();
  }

  getAllFamilyofDetectors() {
    return Backend.POLICIES.getAllFamilyofDetectors(this.policy)
  }

  getAllDetectorOfFam(family: string) {
    return Backend.POLICIES.getDetectorsByFamily(this.policy, family)
  }

  /** allow to scroll immediatly at the HTML element concerned */
  scroolTo(id: string) {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
  }

  /**
   * Format a display in the html table
   * 
   * @param detector 
   * @returns 
   */
  statutactive(detector: Detectors) {
    const dactif = this.policy?.activatedDetectors?.find(elem =>
      elem.policyDetectorId &&
      elem.policyDetectorId.detector.name === detector.name &&
      elem.policyDetectorId.detector.id === detector.id
    );
    return dactif ? '' : 'inactive';
  }

  /**
   * Format a display in the html table
   * 
   * @param detector 
   * @returns 
   */
  formatStatus(detector: Detectors): string {
    const dactif = this.policy?.activatedDetectors?.find(elem =>
      elem.policyDetectorId &&
      elem.policyDetectorId.detector.name === detector.name &&
      elem.policyDetectorId.detector.id === detector.id
    );
    const st = dactif?.status?.toLowerCase();
    const result = Backend.POLICIES.formatStatut(st);
    if (typeof result === 'string') {
      return result;
    } else if (result && typeof result.subscribe === 'function') {
      let value = '';
      result.subscribe((v: string) => value = v).unsubscribe();
      return value;
    }
    return '';
  }

  /**
   * Format a display in the html table
   * 
   * @param detector 
   * @returns string
   */
  formatPId(detector: Detectors): string {
    const dactif = this.policy?.activatedDetectors?.find(elem =>
      elem.policyDetectorId &&
      elem.policyDetectorId.detector.name === detector.name &&
      elem.policyDetectorId.detector.id === detector.id
    );
    const lstatus: string[] = [];
    if (dactif) {
      if (dactif.launchOnDemand) lstatus.push('on demand');
      if (dactif.launchOnPeriodic) lstatus.push('periodic');
    }
    const result = Backend.POLICIES.formatPId(lstatus);
    if (typeof result === 'string') {
      return result;
    } else if (result && typeof result.subscribe === 'function') {
      let value = '';
      result.subscribe((v: string) => value = v).unsubscribe();
      return value;
    }
    return '';
  }

  openFullScreen(content: TemplateRef<any>) {
    this.modalref = this.modalService.open(content, { fullscreen: true, scrollable: true })
  }

  openCenteredVertically(content: TemplateRef<any>) {
    this.modalref = this.modalService.open(content, { centered: true });
  }

  modaldismiss(action: string) {
    this.modalref?.close(action)
  }

  editPolicy(event: { policy: Policy, toast: string }) {
    this.editPtoMain.emit(event)
  }

  async changeName() {
    if (this.policy) {
      this.policy.name = this.editform.value;
      this.policy.activatedDetectors = Backend.POLICIES.formatActiveDetectorsToPost(this.policy.activatedDetectors);
      const keys = ['security-policies-toast-policy', 'security-policies-toast-edit-change'];
      forkJoin([
        this.translationService.get(keys[0]),
        this.translationService.get(keys[1])
      ]).subscribe(([policyText, editChangeText]) => {
        const toast = `${policyText}${this.policy?.name}${editChangeText}`;
        this.editPolicy({ policy: this.policy!, toast });
      });
    }
  }

  /**
   * Duplicate the policy selected
   * 
   * Showing the toast change according to success or failed
   */

  async emitDuplicate() {
    if (this.policy) {
      const activDetects = Backend.POLICIES.formatActiveDetectorsToPost(this.policy.activatedDetectors);
      const clonePol: RequestPolicy = {
        name: this.policy.name + "(D)",
        idBW: this.policy.bwVersion!.id,
        activatedDetectors: activDetects,
        clientName: this.policy.clientPolicyDto?.name
      };
      try {
        await Backend.POLICIES.postPolicy(clonePol);
        forkJoin([
          this.translationService.get('security-policies-toast-policy'),
          this.translationService.get('security-policies-toast-duplicate')
        ]).subscribe(([policyText, duplicateText]) => {
          this.toastService.show(
            `${policyText}${clonePol.name}${duplicateText}`,
            { classname: 'bg-success', delay: 5000 }
          );
        });
        this.duplicateEvent.emit('simulation');
      } catch (error) {
        const err = error as HttpErrorResponse;
        this.toastService.show(err.error.error, { classname: 'bg-danger', delay: 5000 });
      }
    }
  }

  formCheck() {
    return !!(this.editform && this.policy && this.editform.dirty && this.editform.value !== this.policy.name);
  }

  /**
   * Emit the policy to parent
   * 
   * The parent will received the event and delete it himself
   */
  emitDelete() {
    if (this.policy) {
      this.deletePtoMain.emit(this.policy);
    }
  }

  public getFatalLength(family: string) {
    return Backend.POLICIES.getFatalLength(this.policy?.activatedDetectors, family)
  }
  public getTotalLength(family: string) {
    return Backend.POLICIES.getTotalLength(this.policy?.bwVersion?.listDetectors, family)
  }

  public getAction(event: string) {
    document.getElementById(event)?.click()
  }

  /**
   * Emit event action to parent with the policy in on object
   * 
   * @param event 
   */
  public sendAction(event: string) {
    if (this.policy) {
      this.status.emit({ action: event, policy: this.policy })
    }
  }


  /**
   * Emit the submitPolicy Event with an object compose by the policy && appid user want to link 
   * 
   * @param id 
   */
  public submitEvent(id: number) {
    if (this.policy) {
      this.submitPolicy.emit({ policy: this.policy, applicationId: id })
    }
  }

  public checkStatus() {
    return this.policy?.status == "SUBMITTED" || this.policy?.status == "CREATED"
  }

}
